<template>
  <div class="login-box">
    <!-- <plate-input :data.sync="plateStr">
     <el-input v-model="plateStr" placeholder="请输入车牌" />
    </plate-input> -->
    <div class="logo-img">
      <img src="@/assets/img/login_logo.png" />
      <p>车都停车岗亭系统</p>
    </div>
    <div class="err-msg">
      {{ showErrorInfo }}
    </div>
    <el-input
      v-model.trim="loginForm.username"
      class="login-input"
      type="text"
      name="username"
      autocomplete="on"
      prefix-icon="el-icon-user"
      placeholder="请输入账号"
    />
    <el-input
      v-model.trim="loginForm.password"
      class="login-input"
      type="password"
      name="password"
      prefix-icon="el-icon-lock"
      placeholder="请输入密码"
      @keyup.enter="handleLogin"
    />
    <div class="login-btn" @click="handleLogin">登录</div>
  </div>
</template>

<script>
// import { isvalidUsername } from "@/utils/validate";
// import { reg, checkReg } from "@/utils/RegExp";
import { toLogin } from "@/api/module/login";
import { setToken, setRoleCode, setUserId, setSetFreeOpenGate } from "@/utils/service";
import { curlSentryUserConfig } from "@/api/module/tenant";

export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      showErrorInfo: "",
      baseURL: { baseURL: "http://xx.xxx.com" },
      plateStr: "",
    };
  },

  methods: {
    async handleLogin() {
      if (this.loginForm.username === "" || this.loginForm.password === "") {
        this.showErrorInfo = "用户名和密码不能为空!";
        return false;
      }
      // if (!isvalidUsername(this.loginForm.username)) {
      //   this.showErrorInfo = "用户名格式错误!";
      //   return false;
      // }
      // if (!checkReg(reg["password"], this.loginForm.password)) {
      //   this.showErrorInfo = "密码长度6~16,至少一个数字和字母,区分大小写!";
      //   return false;
      // }
      this.showErrorInfo = "";
      let res = await toLogin({
        Account: this.loginForm.username,
        Password: this.loginForm.password,
      });
      // console.log('登录结果',res)
      if (res.state === "success") {
        let data = res.data;
        setToken(data.Token);
        setUserId(data.Id);
        this.$store.dispatch("SetUserInfo", data);
        this.$store.dispatch("SetUserName", data.Account);
        this.$store.dispatch("SetIsCashier", data.Role.RoleCode);
        setRoleCode(data.Role.RoleCode);
        this.getSetting();
        // let TenantId =Number(data.TenantId);
        // TenantId===18?this.$router.push("/ZS/tenant/"):this.$router.push("/home/tenant/");
        this.$router.push("/home/tenant/");
      } else {
        this.showErrorInfo = res.message;
      }
    },
    getSetting() {
      curlSentryUserConfig().then((res) => {
        if (res.state === "success") {
          setSetFreeOpenGate(res.data.FreeOpenGate)
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.login-box {
  overflow: hidden;
  width: 542px;
  height: 610px;
  background: #ffffff;
  box-shadow: 0px 10px 60px #2a4897;
  opacity: 1;
  border-radius: 16px;
  background: #fff;
  font-size: 16px;
  position: fixed;
  right: 176px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  text-align: center;
  .logo-img {
    width: 240px;
    margin: 40px auto;
    // height: 89px;
    // background: url("../../../assets/img/login_logo.png") no-repeat;
    // background-size: 100% 100%;
    & img {
      margin-top: 66px;
      margin-bottom: 10px;
    }
    & p {
      width: 240px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      opacity: 1;
    }
  }
  .err-msg {
    font-size: 14px;
    color: #fe0000;
    width: 320px;
    height: 20px;
    line-height: 20px;
    margin: 33px auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .login-btn {
    width: 320px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #0178ec;
    border-radius: 50px;
    color: #fff;
    margin: 0 auto 0;
    user-select: none;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.login-input {
  width: 312px;
  height: 40px;
  line-height: 40px;
  border: none;
  outline: none;
  color: #222;
  margin-bottom: 40px;
  .el-input__inner {
    border: 0;
    border-bottom: 1px solid #eee;
  }
  &:focus {
    border-bottom: 1px solid #0178ec;
  }
  &::-webkit-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }
}
</style>
